import React from "react";
import "./ProjectDetail.css";

const ProjectDetail = ({ project, show, onClose }) => {
  const {
    name,
    role,
    description,
    skills,
    createdAt,
    images,
    androidLink,
    iosLink,
    gitLink,
    webLink,
  } = project;

  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          &times;
        </button>

        <div className="project-detail-container">
          <div className="project-text-content">
            <h2 className="project-title">{name}</h2>
            <p className="project-role">My role: {role}</p>
            <h3 className="project-section-title">Project description</h3>
            <div
              className="project-description project-align-left"
              dangerouslySetInnerHTML={{ __html: description }}
            />
            <div className="project-skills">
              {skills &&
                skills.map((skill, index) => (
                  <span key={index} className="skill-tag">
                    {skill}
                  </span>
                ))}
            </div>
            <p className="project-published-date">Published on {createdAt}</p>

            <div className="project-link project-align-left">
              {androidLink && (
                <span>
                  <a target="_blank" href={androidLink}>
                    <span
                      className="iconify"
                      data-icon="logos:google-play-icon"
                    ></span>
                  </a>
                </span>
              )}
              {iosLink && (
                <span>
                  <a target="_blank" href={iosLink}>
                    <span
                      className="iconify"
                      data-icon="logos:apple-app-store"
                    ></span>
                  </a>
                </span>
              )}
              {gitLink && (
                <span>
                  <a target="_blank" href={gitLink}>
                    <span className="iconify" data-icon="logos-git"></span>
                  </a>
                </span>
              )}
              {webLink && (
                <span>
                  <a target="_blank" href={webLink}>
                    <span className="iconify" data-icon="mdi:web"></span>
                  </a>
                </span>
              )}
            </div>
          </div>

          <div className="project-image-content">
            {images.map((url, index) => (
              <img
                key={index}
                src={url}
                className="project-main-image"
                alt={`Project ${name}`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetail;
